const Fn = [
    0,7,16,27,40,55,72,91,112,135,
    160,187,216,247,280,315,352,394,441,493,550,
    612,679,751,828,910,997,1089,1186,1288,1395,
    1507,1628,1758,1897,2045,2202,2368,2543,2727,2920,
    3130,3348,3574,3808,4050,4300,4558,4824,5098,5380,
    5670,5968,6266,6564,6862,7160,7458,7756,8054,8352,
    8650,8948,9246,9544,9842,10140,10438,10736,11034,11332
]

//state[1] = 7


const baseJobEXPChartReducer = (state = Fn, action) => {
    switch(action.type){
        default:
            return state;
    }
}

export default baseJobEXPChartReducer;